import { create, v, w } from '@dojo/framework/core/vdom';
import { createICacheMiddleware } from '@dojo/framework/core/middleware/icache';
import { theme } from '@dojo/framework/core/middleware/theme';
import { createNlsMiddleware, userstate } from 'lcc-state';
import { createProgressionMiddleware } from '../middleware/progression';
import { quizstate, quizChange, setQuestion, setProgressionIsrunning, infoChange } from '../support/state';
import { QuestionQueue } from '../support/questionqueue';
import { ScoreRollup } from '../support/score-rollup';
import { svc } from '../support/ss-svc';
import { svc as quizsvc } from '../support/quizsvc';
import css from '../css/singlestep.m.css';
const nls = createNlsMiddleware('quiz');
const progression = createProgressionMiddleware();
const icache = createICacheMiddleware();
const factory = create({ icache, nls, theme, progression, quizstate, userstate }).properties();
export const SingleStep = factory(({ properties, middleware: { icache, nls, theme, progression, quizstate, userstate } }) => {
    icache.getOrSet('inited', () => {
        const { quizstore } = properties();
        quizstate.setStore(quizstore);
        progression.setStore(quizstore);
        progression.initialize();
        progression.svc = svc;
        return true;
    });
    const props = () => {
        const { get, path } = quizstate;
        const theProps = Object.assign({}, progression.getProperties(), properties(), {
            question: get(path('question'))
        });
        return theProps;
    };
    const themeCss = theme.classes(css);
    const finalize = async () => {
        const { get, path } = userstate;
        const { svc } = progression;
        const userid = get(path('user_id'));
        quizstate.run(setProgressionIsrunning)({ isrunning: 'final' });
        const [quiz, info] = await Promise.all([svc.quiz(), svc.info()]);
        icache.delete('started');
        quizstate.run(quizChange)({ quiz });
        quizstate.run(infoChange)({ info });
        quizstate.run(setQuestion)({ question: undefined });
        await quizsvc.update_annotation({ userid });
        return true;
    };
    progression.finalize = finalize;
    const render_page = () => {
        const { isPlaceholder, messages: { discActivity, memoActivity, memoFeedbackHead = '[quiz] memoFeedbackHead' } } = nls();
        if (isPlaceholder) {
            return [];
        }
        const { quiz = {}, quizstore, info, question } = props();
        const { finalize, startquiz, svc } = progression;
        const activityHead = question && question.questiontype === 'Discussion' ? discActivity : memoActivity;
        let showFeedback = false;
        let feedback = '';
        if (info && question) {
            const { start_state } = info;
            showFeedback =
                question.questiontype !== 'Discussion' && (start_state === 'posted' || start_state === 'graded');
            if (showFeedback) {
                feedback = question.feedback;
            }
        }
        icache.getOrSet('started', async () => {
            const { get, path } = quizstate;
            let info = get(path('info'));
            if (!info || info.numberofquestions === 0) {
                await progression.load_quiz();
                info = get(path('info'));
            }
            const status = info.start_state;
            progression.startquiz = status === 'posted' ? await svc.continue_quiz() : await svc.start_quiz();
            await progression.quiz_startup();
            return true;
        });
        if (!icache.get('started')) {
            return [];
        }
        return [
            showFeedback
                ? v('div', { key: 'feedback', classes: [themeCss.feedback] }, [
                    v('h4', { key: 'feedback-head' }, [memoFeedbackHead]),
                    v('div', { key: 'feedback-body', innerHTML: feedback })
                ])
                : null,
            v('div', { key: 'static' }, [
                v('h4', { classes: [themeCss.activityHead], innerHTML: activityHead }),
                v('div', { classes: [themeCss.instructions], innerHTML: question ? question.text : '' })
            ]),
            v('div', { key: 'content', classes: [themeCss.questionBlock] }, [
                w(QuestionQueue, {
                    key: `${quiz.id}-queue`,
                    svc,
                    finalize,
                    startquiz,
                    quizstore
                })
            ])
        ];
    };
    const { quiz, info, key, quizstore } = props();
    const { load_quiz, render_loading } = progression;
    const hasdata = quiz && info;
    !hasdata && load_quiz();
    return v('div', { key, xqa: `progression single-step`, classes: [themeCss.root] }, hasdata ? [w(ScoreRollup, { key: `rollup-${key}`, quizstore }, render_page())] : render_loading());
});
export default SingleStep;
